import { request } from '@/api'

/**
 * `POST /v1/gates/:id/viewed` (#1774): reports that the member opened a Needs-you item. The session says whose view it
 * is and the server works out the item's type from the gate, so nothing is sent: no type, event or enterprise the
 * server would have to trust. The server records it once per item per person, so a repeat costs nothing.
 */
export async function reportNeedsYouItemViewed(gateId: string): Promise<void> {
    await request<void>(`/v1/gates/${encodeURIComponent(gateId)}/viewed`, { method: 'POST' })
}
